// extracted by mini-css-extract-plugin
module.exports = {"Card":"Advice_Card__PzbME","Heading":"Advice_Heading__2lhti","Btn":"Advice_Btn__1i6rN","rotate":"Advice_rotate__3xBE5","storm":"Advice_storm__2XCuX"};